import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material'
import { AddCircle } from '@mui/icons-material'
import * as React from 'react'
import { useState } from 'react'
import ProtocolModal from './ProtocolModal'
import { useUserContext } from '../../../Contexts/UserConfig'
import { useStudyContext } from '../../../Contexts/Modules/StudyModule/SelectedStudyModule'
import { useParams } from 'react-router-dom'

function EthicsProtocols() {
  const { loginConfig } = useUserContext()
  const { studyEdit } = useStudyContext()
  const { study_id } = useParams()
  const [openModal, setOpenModal] = useState(false)
  return (
    <>
      <Paper
        variant={'outlined'}
        sx={{
          width: 1,
          overflow: 'hidden',
          minHeight: 150,
        }}
      >
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table
            stickyHeader
            size="small"
          >
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, fontSize: '1rem' }}>
                  Associated Ethics Protocols
                </TableCell>
                <TableCell>
                  <IconButton
                    color={'primary'}
                    onClick={() => setOpenModal(true)}
                    sx={{ p: 1 / 3 }}
                    disabled={
                      !loginConfig?.Modules?.EditStudy || study_id === '1'
                    }
                  >
                    <AddCircle />
                  </IconButton>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {studyEdit?.protocols &&
                studyEdit.protocols.map((row) => (
                  <TableRow
                    tabIndex={-1}
                    key={row.ProtocolID}
                  >
                    <TableCell>{row.EthicsNumber}</TableCell>
                    <TableCell sx={{ width: 50 }}></TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <ProtocolModal
        open={openModal}
        setOpen={setOpenModal}
      />
    </>
  )
}

export default EthicsProtocols
